import ReactToggle from "react-toggle";
import { Box, BoxProps } from "../Box";
import "./styles.css";

type ToggleProps = {
  isChecked: boolean;
  isDisabled?: boolean;
  /** Native tooltip — useful for explaining why a disabled toggle is disabled. */
  title?: string;

  onChange: React.ChangeEventHandler<HTMLInputElement>;
  color?: string;
} & BoxProps;

export const Toggle = (props: ToggleProps) => {
  const { isChecked, onChange, isDisabled, title, ...styleProps } = props;

  return (
    <Box {...styleProps} title={title}>
      <ReactToggle
        checked={isChecked}
        onChange={onChange}
        disabled={isDisabled}
      />
    </Box>
  );
};
